import { render, staticRenderFns } from "./micro-page-edit.vue?vue&type=template&id=7854457c&scoped=true&"
import script from "./micro-page-edit.vue?vue&type=script&lang=js&"
export * from "./micro-page-edit.vue?vue&type=script&lang=js&"
import style0 from "./micro-page-edit.vue?vue&type=style&index=0&id=7854457c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854457c",
  null
  
)

export default component.exports